import React, { useEffect, useState } from "react";
import "./FOTopGainerLooser.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function FOTopGainerLooser() {

    const { foTopGainerLooserData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );

    const [foTopGainerData, setFoTopGainerData] = useState([]);
    const [foTopLooserData, setFoTopLooserData] = useState([]);

    // 🔥 Separate sorting states
    const [gainerSortOrder, setGainerSortOrder] = useState(null);
    const [looserSortOrder, setLooserSortOrder] = useState(null);

    /* ================= DATA ================= */

    useEffect(() => {
        if (foTopGainerLooserData) {
            setFoTopGainerData(foTopGainerLooserData?.FO_TOP_GAINERS?.data || []);
            setFoTopLooserData(foTopGainerLooserData?.FO_TOP_LOOSERS?.data || []);
        }
    }, [foTopGainerLooserData]);

    /* ================= HELPERS ================= */

    const formatPercentage = (value) => {
        if (value == null || isNaN(value)) return "--";

        return Number(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    // 🔥 Sorting handlers
    const handleGainerSort = () => {
        setGainerSortOrder(prev =>
            prev === "asc" ? "desc" : prev === "desc" ? null : "asc"
        );
    };

    const handleLooserSort = () => {
        setLooserSortOrder(prev =>
            prev === "asc" ? "desc" : prev === "desc" ? null : "asc"
        );
    };

    // 🔥 Sorting logic
    const getSortedData = (data, sortOrder) => {
        if (!sortOrder) return data;

        return [...data].sort((a, b) => {
            const aVal =
                a.prev_price != null && a.open_price != null
                    ? Math.abs(a.prev_price - a.open_price)
                    : -Infinity;

            const bVal =
                b.prev_price != null && b.open_price != null
                    ? Math.abs(b.prev_price - b.open_price)
                    : -Infinity;

            return sortOrder === "asc" ? aVal - bVal : bVal - aVal;
        });
    };

    /* ================= UI ================= */

    return (
        <div className="fo-top-gainer-looser">
            <div className="table-container">

                {/* ================= GAINERS ================= */}
                <div className="top-gainer-looser-header">
                    <h2 className="top-gainer-looser-heading">
                        <span className="top-gainer-looser-span">F&O TOP GAINERS</span>
                    </h2>
                </div>

                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">
                    <thead>
                        <tr>
                            <th>SYMBOL</th>
                            <th>OPEN</th>
                            <th>HIGH</th>
                            <th>LOW</th>
                            <th>PREV CLOSE</th>
                            {/* 🔥 Gainer Sorting */}
                            <th onClick={handleGainerSort} style={{ cursor: "pointer" }}>
                                PDC-OPEN {gainerSortOrder === "asc" ? "↑" : gainerSortOrder === "desc" ? "↓" : ""}
                            </th>
                            <th>LTP</th>
                            <th>CHNG(%)</th>
                            <th>VOLUME(shares)</th>
                            <th>VOLUME(lakh)</th>

                            
                        </tr>
                    </thead>

                    <tbody>
                        {foTopGainerData?.length > 0 ? (
                            getSortedData(foTopGainerData, gainerSortOrder).map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.symbol ?? "--"}</td>
                                    <td>{formatPercentage(row.open_price)}</td>
                                    <td>{formatPercentage(row.high_price)}</td>
                                    <td>{formatPercentage(row.low_price)}</td>
                                    <td>{formatPercentage(row.prev_price)}</td>
                                    {/* 🔥 Absolute PDC */}
                                    <td>
                                        {row.prev_price != null && row.open_price != null
                                            ? formatPercentage(Math.abs(row.prev_price - row.open_price))
                                            : "--"}
                                    </td>
                                    <td>{formatPercentage(row.ltp)}</td>

                                    <td className={
                                        row.perChange == null
                                            ? ""
                                            : Number(row.perChange) >= 0
                                                ? "positive"
                                                : "negative"
                                    }>
                                        {row.perChange != null
                                            ? `${Number(row.perChange) >= 0 ? "+" : ""}${Number(row.perChange).toFixed(2)}%`
                                            : "--"}
                                    </td>

                                    <td>{formatPercentage(row.trade_quantity)}</td>
                                    <td>{formatPercentage(row.turnover)}</td>

                                    
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="15">Waiting for live data...</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* ================= LOOSERS ================= */}
                <div className="top-gainer-looser-header">
                    <h2 className="top-gainer-looser-heading">
                        <span className="top-gainer-looser-span">F&O TOP LOOSERS</span>
                    </h2>
                </div>

                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">
                    <thead>
                        <tr>
                            <th>SYMBOL</th>
                            <th>OPEN</th>
                            <th>HIGH</th>
                            <th>LOW</th>
                            <th>PREV CLOSE</th>
                             {/* 🔥 Looser Sorting */}
                            <th onClick={handleLooserSort} style={{ cursor: "pointer" }}>
                                PDC-OPEN {looserSortOrder === "asc" ? "↑" : looserSortOrder === "desc" ? "↓" : ""}
                            </th>
                            <th>LTP</th>
                            <th>CHNG(%)</th>
                            <th>VOLUME(shares)</th>
                            <th>VOLUME(lakh)</th>

                           
                        </tr>
                    </thead>

                    <tbody>
                        {foTopLooserData?.length > 0 ? (
                            getSortedData(foTopLooserData, looserSortOrder).map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.symbol ?? "--"}</td>
                                    <td>{formatPercentage(row.open_price)}</td>
                                    <td>{formatPercentage(row.high_price)}</td>
                                    <td>{formatPercentage(row.low_price)}</td>
                                    <td>{formatPercentage(row.prev_price)}</td>
                                    <td>
                                        {row.prev_price != null && row.open_price != null
                                            ? formatPercentage(Math.abs(row.prev_price - row.open_price))
                                            : "--"}
                                    </td>
                                    <td>{formatPercentage(row.ltp)}</td>

                                    <td className={
                                        row.perChange == null
                                            ? ""
                                            : Number(row.perChange) >= 0
                                                ? "positive"
                                                : "negative"
                                    }>
                                        {row.perChange != null
                                            ? `${Number(row.perChange) >= 0 ? "+" : ""}${Number(row.perChange).toFixed(2)}%`
                                            : "--"}
                                    </td>

                                    <td>{formatPercentage(row.trade_quantity)}</td>
                                    <td>{formatPercentage(row.turnover)}</td>

                                    
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="15">Waiting for live data...</td>
                            </tr>
                        )}
                    </tbody>

                    <tfoot className="fixed-footer">
                        <tr>
                            <td colSpan="15">noptionwave © 2026</td>
                        </tr>
                    </tfoot>
                </table>

            </div>
        </div>
    );
}